// region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Method to validate the organisation data.
//
//  Copyright:    © 2026 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
// region Version 1.0.0.0
//    001   16.01.26 Sean Flook         GMSCM-12 Initial Revision.
// endregion Version 1.0.0.0
//
//--------------------------------------------------------------------------------------------------
// endregion header

import { OrganisationErrorType } from "../models/organisationErrorType";
import OrganisationGridType from "../models/organisationGridType";

export const validateOrganisationData = (data: OrganisationGridType[]): OrganisationErrorType[] => {
  let organisationErrors: OrganisationErrorType[] = [];

  if (data && data.length > 0) {
    data.forEach((organisation) => {
      // Validate that the organisation name is not empty.
      if (!organisation || organisation.organisation.trim() === "") {
        organisationErrors.push({
          id: organisation.id,
          field: "name",
          error: "Organisation name cannot be empty.",
        });
      }

      // Validate that the organisation name does not equal "_New Organisation".
      if (organisation.organisation === "_New Organisation") {
        organisationErrors.push({
          id: organisation.id,
          field: "name",
          error: "Organisation name cannot be '_New Organisation'. Please choose a different name.",
        });
      }

      // Validate that the organisation name is unique.
      const duplicateOrgs = data.filter((org) => org.organisation === organisation.organisation);
      if (duplicateOrgs.length > 1) {
        organisationErrors.push({
          id: organisation.id,
          field: "name",
          error: `Organisation name '${organisation.organisation}' must be unique.`,
        });
      }
    });
  }

  return organisationErrors;
};
